// eslint-disable-next-line
import React, { useContext, Fragment } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { getTime } from '../../utils/convert-time'
import { Loading } from '../helpers/Loading'
import { httpToHttps } from '../../utils/helper-functions'
import { RiHeartLine, RiMore2Line, RiPlayLine } from 'react-icons/ri'

/** Suggested Search results main component**/
export const SearchResultMain = ( { results, loading, onSearchSelect, order } ) => {
  // eslint-disable-next-line
  const history = useHistory()
  let playlists = []
  let artists
  let tracksArr = []
  let albums = []

  if ( results && results.songs !== undefined ) {
    tracksArr = results.songs.map( ( song, i ) => {
      return (
        // Search-results.scss
        <li key={song?.id} className="results__item" id="tracks">
          <span>{i + 1}</span>
          <Link to={`/song/${song?.id}`}>
            <p>{song.name}</p>
            <p>
              {song?.artists?.map( ( { name } ) => name ).join( " & " )}
            </p>
          </Link>
          <span>{getTime( song?.duration )}</span>
          <span>
            <RiPlayLine
              onClick={() => handlePlayTrack( i )}
            />
          </span>
          <span className="heart__svg">
            <RiMore2Line />
          </span>
        </li>
      )
    } )
    
    if ( results && results.artists ) {
      artists = results.artists.map( artist => {
        return (
          <Link
            key={artist.id}
            to={`/artists/${artist.id}`}
            onClick={() => onSearchSelect( artist )}>
            <li className="results__item" id="artist">
              <img
                src={httpToHttps( artist.img1v1Url ) + "?param=100y100"}
                alt={artist.name}
                loading="lazy"
              />
              <p>{artist.name}
                <br />
                <span className="search__item span">
                  Artist
                </span>
              </p>
              {/* <span>
                <RiPlayLine />
              </span> */}
              {/* <span className="heart__svg">
                <RiHeartLine fill="currentColor" w="0.8em" h="0.8em" />
              </span> */}
              {/* <span className="heart__svg">
                <RiMore2Line fill="currentColor" />
              </span> */}
            </li>
          </Link>
        )
      } )
    }
    if ( results && results.albums ) {
      albums = results.albums.map( album => {
        return (
          <Link
            key={album.id}
            to={`/album/${album.id}`}
            className="">
            <li className="results__item" id="albums">
              <img
                src={httpToHttps( album.artist.picUrl ? album.artist.picUrl : album.artist.img1v1Url ) + "?param=100y100"}
                alt={album.name}
                loading="lazy"
              />
              <p className="search__item p">
                {album.name}
                <br />
                <span className="search__item span">
                  {album.artist?.name}
                </span>
              </p>
              <span>
                <RiPlayLine fill="currentColor"
                />
              </span>
              <span className="heart__svg">
                <RiMore2Line fill="currentColor" h="0.8em"
                />
              </span>
            </li>
          </Link>
        )
      } )
    }
  }
  //inner__artists
  return (
    <div className="search__results overlay">
      {loading ? <Loading />
        : <div className="results__wrapper">
          {results && results !== []
            ? <Fragment>
              <ul className="results__list">
                {artists}
              </ul>
              <ul className="results__list">
                {tracksArr}
              </ul>
              <ul className="results__list">
                {albums}
              </ul>
              <ul className="results__list">
                {playlists}
              </ul>
            </Fragment>
            : null
          }
        </div>
      }
    </div>
  )
}